import React, { useEffect, useState } from "react";
import "./style.scss";
import CreateRequest from "../../Components/Createrequest";
import CategoryList from "../../Components/CategoryList";
import RequestDetails from "../../Components/RequestDetail";
import Servicedetail from "../../Components/Servicedetail";
import Api from "../../Utils/Api";
import Storelist from "../../Store/Actions";
import Slotaccept from "../../Components/InRequest/SlotAccept";
import RescheduleModal from '../../Components/RescheduleModal/RescheduleModal'
const Dashboard = () => {
const {PageStore,ServiceDetailsStore} = Storelist();
const {GetbikeTypesList,_GetRequestByID} = Api()
  



  return (
    <div className="dashboard-container">
      <CategoryList />
      {PageStore?.is_create_modal&&<CreateRequest />}
      {PageStore?.is_create_modal&&<Servicedetail />}
      {!_GetRequestByID?.loading&&ServiceDetailsStore?.data!==null&&<RequestDetails />}
      {!_GetRequestByID?.loading&&(ServiceDetailsStore?.data?.bikeRequest?.serviceStatus==='New'||ServiceDetailsStore?.data?.bikeRequest?.serviceStatus==='Accepted')&&<Slotaccept />}
      {PageStore?.is_reschedule_modal&&<RescheduleModal/>}
    </div>
  );
};

export default Dashboard;
